import { render } from "./despesas-table.vue?vue&type=template&id=1c88c526"
import script from "./despesas-table.vue?vue&type=script&lang=js"
export * from "./despesas-table.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__